/** A pulsing placeholder bar for content that has not arrived. The caller
 * sizes it to the exact box the real content will occupy, so nothing moves
 * when the content lands. */
export default function Skeleton({ className }: { className: string }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block animate-pulse rounded bg-oat-200 ${className}`}
    />
  );
}
